module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M24.856 31.798l-8.855-4.872-8.855 4.872c-.886.488-1.47.062-1.306-.956l1.696-10.345-7.122-7.268c-.712-.726-.484-1.442.512-1.59l9.829-1.494L15.211.694c.438-.928 1.146-.928 1.584 0l4.454 9.451 9.829 1.494c.996.148 1.224.864.512 1.59l-7.122 7.268 1.696 10.345c.162 1.018-.422 1.446-1.308.956z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/star-2.js
// module id = 1432
// module chunks = 14